import * as React from "react"
import {
  Modal,
  StyledModal,
  StyledModalHeader,
  StyledModalBody,
  StyledModalActions,
  Button,
  Text,
  ModalCard,
} from "gatsby-interface"
import { siteTransfer as text, ui as uiText } from "@modules/locales/default.js"

export type TransferSiteCancelModalProps = {
  isOpen: boolean
  onDismiss: () => void
  onConfirm: () => void
  loading: boolean
  error: JSX.Element | null
}

export function TransferSiteCancelModal({
  isOpen,
  onDismiss,
  onConfirm,
  loading,
  error,
}: TransferSiteCancelModalProps) {
  return (
    <Modal isOpen={isOpen} aria-label={``} onDismiss={onDismiss} type="error">
      <ModalCard>
        <StyledModal variant="WARNING">
          <StyledModalHeader onCloseButtonClick={onDismiss}>
            {text.headers.cancelTransfer}
          </StyledModalHeader>
          <StyledModalBody>
            <Text>{text.messages.areYourSureYouWantToCancelTransfer}</Text>

            {error}

            <StyledModalActions>
              <Button
                variant="SECONDARY"
                tone="NEUTRAL"
                type="button"
                onClick={onDismiss}
              >
                {uiText.actions.cancel}
              </Button>
              <Button
                variant="PRIMARY"
                tone="DANGER"
                type="submit"
                data-cy="revoke-invite-cta"
                onClick={onConfirm}
                loading={loading}
                disabled={loading}
                loadingLabel={text.labels.canceling}
              >
                {text.labels.cancelTransfer}
              </Button>
            </StyledModalActions>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}
